module.exports = __webpack_public_path__ + "static/media/microsoft-business.e11e814e.svg";